// extracted by mini-css-extract-plugin
module.exports = {"facebookID":"facebookID_facebookID__-5ued"};